import * as React from 'react'
import { Modal } from 'react-bootstrap'
import TrueNativeEditorContainer from './TrueNativeEditorContainer'
import { TrueNativeArticle } from './articleManagement/types'

interface Props {
	show: boolean
	onClose: () => void
	campaignId?: number
	initialData?: TrueNativeArticle
}

const TrueNativeEditorModal = ({ show, onClose, campaignId, initialData }: Props) => {
	const handleSave = () => {
		onClose()
	}

	const handleCancel = () => {
		onClose()
	}

	return (
		<Modal show={show} onHide={onClose} bsSize="large">
			<Modal.Header closeButton style={{ border: 'none', padding: '15px 20px 0' }}></Modal.Header>
			<Modal.Body style={{ padding: '20px', minHeight: '80vh' }}>
				<TrueNativeEditorContainer
					campaignId={campaignId?.toString() ?? 'test'}
					initialData={initialData}
					onSave={handleSave}
					onCancel={handleCancel}
				/>
			</Modal.Body>
		</Modal>
	)
}

export default TrueNativeEditorModal
